export default __webpack_public_path__ + "static/media/Logo.3955ade6.svg";